<template>
  <div class="tab-card">
    <header class="card-header">
      <ul class="tab-heads">
        <li
          class="tab-head"
          v-for="tab in tabs"
          :key="tab"
          :class="{'tab-head-active' : activeTab === tab}"
          @click="switchTab(tab)"
        >
          <slot :name="tabHeadSlotName(tab)">
            {{tab}}
          </slot>
        </li>
      </ul>
    </header>
    <main class="tab-card-body">
      <div class="tab-panel">
        <slot :name="tabPanelSlotName"></slot>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    initialTab: String,
    tabs: Array
  },
  data() {
    return {
      activeTab: this.initialTab
    }
  },
  computed: {
    tabPanelSlotName(tabName) {
      return `tab-panel-${this.activeTab}`
    }
  },
  methods: {
    tabHeadSlotName(tabName) {
      return `tab-head-${tabName}`
    },

    switchTab(tabName) {
      this.activeTab = tabName
      this.$emit('switch-tab', tabName)
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '../../styles/base/variables'

  .tab-heads
    display: flex
    align-items: center
    justify-content: center
    padding: 0
    list-style: none
    .tab-head
      width: 33.3%
      padding: 15px
      font-size: 12px
      border-bottom: 2px solid transparent
      background: $color-grey-lighter
      text-align: center
      cursor: pointer
      &.tab-head-active
        border-bottom: 2px solid $color-primary

  .tab-card-body
    padding: 30px
</style>


// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Tabs.vue